/**
 * @description - Main js file, this file is watched by webpack, contains all main imports
 *
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 */

import 'normalize.css';
import '../scss/main.scss';

/* eslint-disable */

/**
 * @description Import all images from images folder
 * @return {Object} - Object with all images and there paths
 *
 */
function importAll(r) {
    let images = {};
    r.keys().map((item, index) => {
        images[item.replace('./', '')] = r(item);
    });
    return images;
}

const images = importAll(require.context('../images', false, /\.(png|jpe?g|svg)$/));
// import video from '../videos/video.mp4';

/* eslint-enable */

// import web app js scripts
import './_polyfill';
import './_form-validation';
import './_modal-img';
import './_preview-slider';
import './_article-slider';
import './_faq';
import './_app';
import './_studies';
import './_presentations';
import './_products';
